import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { fetchProducts } from "@/lib/api";

export default function FeaturedSection() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    fetchProducts({ featured: true }).then((d) => setProducts(d.slice(0, 6))).catch(() => {});
  }, []);
  if (products.length === 0) return null;
  return (
    <section className="border-b border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-sky-700">Catalog</span>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">Featured Equipment</h2>
          </div>
          <Button asChild variant="outline" className="rounded-sm border-slate-300" data-testid="featured-view-all">
            <Link to="/shop">View all equipment <ArrowRight className="h-4 w-4" /></Link>
          </Button>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </section>
  );
}
